import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: '/',
      meta: {
        name: '首页',
        type: 'desktop'
      },
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/IWant',
      name: 'IWant',
      meta: {
        name: '我要用平台'
      },
      component: () => import('@/views/IWant.vue')
    },
    {
      path: '/information',
      name: 'information',
      meta: {
        name: '智慧生物信息库'
      },
      component: () => import('@/views/Information.vue')
    },
    {
      path: '/sample',
      name: 'sample',
      meta: {
        name: '智慧生物样本库'
      },
      component: () => import('@/views/Sample.vue')
    },
    {
      path: '/sampleA',
      name: 'sampleA',
      meta: {
        name: '智慧生物样本库'
      },
      component: () => import('@/views/SampleA.vue')
    },
    {
      path: '/retrieval',
      name: 'retrieval',
      meta: {
        name: '高级检索'
      },
      component: () => import('@/views/Retrieval.vue')
    },

    {
      path: '/achievement1',
      name: 'achievement1',
      meta: {
        name: '学术荣誉与获奖'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/achievement2',
      name: 'achievement2',
      meta: {
        name: '科研项目'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/achievement2',
      name: 'achievement2',
      meta: {
        name: '发表论文'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/news',
      name: 'news',
      meta: {
        name: '新闻热点'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/introduction',
      name: 'introduction',
      meta: {
        name: '中心介绍'
      },
      component: () => import('@/views/Introduction.vue')
    },
    {
      path: '/direction',
      name: 'direction',
      meta: {
        name: '理念与目标'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/organizational',
      name: 'organizational',
      meta: {
        name: '组织架构'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/history',
      name: 'history',
      meta: {
        name: '建设历程'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/share',
      name: 'share',
      meta: {
        name: '共享合作共识'
      },
      component: () => import('@/views/Waiting.vue')
    },
    {
      path: '/waiting',
      name: 'waiting',
      meta: {
        name: '建设中'
      },
      component: () => import('@/views/Waiting.vue')
    }
  ]
})

export default router
